export default {"src":"/_next/static/media/connection_icon.14cfe9ac.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};